import { ReactNode } from "react";
import { Colors } from "shared/styles";
import styled, { CSSProp } from "styled-components";
import tw from "twin.macro";

type Props = {
  radioGroupName: string;
  label: ReactNode;
  value: string;
  hint?: string;
  onChange: (value: string) => void;
  checked: boolean;
  disabled?: boolean;
  className?: string;
  inputStyle?: CSSProp;
  labelStyle?: CSSProp;
  hintStyle?: CSSProp;
};

const Radio = ({
  radioGroupName,
  label,
  value,
  hint,
  onChange,
  checked,
  disabled,
  className,
  inputStyle,
  labelStyle,
  hintStyle,
}: Props) => {
  return (
    <div
      key={value}
      tw="grid grid-flow-col gap-x-2 items-center justify-start my-4"
      className={className}
    >
      <Input
        type="radio"
        name={radioGroupName}
        id={value}
        onChange={() => onChange(value)}
        value={value}
        checked={checked}
        css={[inputStyle, disabled && tw`cursor-not-allowed`]}
        disabled={disabled}
      />
      <label
        htmlFor={value}
        tw="font-base text-xs leading-4 cursor-pointer flex flex-col"
        css={[labelStyle, disabled && tw`cursor-not-allowed opacity-60`]}
      >
        {label}
        {hint && (
          <span tw="font-light text-[8px] text-black mt-2" css={hintStyle}>
            {hint}
          </span>
        )}
      </label>
    </div>
  );
};

const Input = styled.input`
  width: 28px;
  height: 28px;
  border-radius: 14px;
  background: ${Colors.blue["01"]};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:checked {
    &:before {
      content: "";
      display: block;
      width: 14px;
      height: 14px;
      border-radius: 7px;
      background: ${Colors.gradient["01"]};
    }
  }
`;

export default Radio;
